import React from 'react'
import styled from 'styled-components'

const SideBarMenu = ({ children }) => <Menu>{children}</Menu>

const Menu = styled.ul``

export default SideBarMenu
